import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface PersonSearchIconProps {
  size?: number
  color?: string
}

/**
 * "person_search" icon, exact vector from Figma (node 20123:50288). Used by the
 * empty/no-results card in the Roster Add Player modal.
 */
const PersonSearchIcon: React.FC<PersonSearchIconProps> = ({
  size = 40,
  color = colors.NEUTRAL_50,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.6667 18.3333C20.35 18.3333 23.3333 15.35 23.3333 11.6667C23.3333 7.98333 20.35 5 16.6667 5C12.9833 5 10 7.98333 10 11.6667C10 15.35 12.9833 18.3333 16.6667 18.3333ZM16.6667 8.33333C18.5 8.33333 20 9.83333 20 11.6667C20 13.5 18.5 15 16.6667 15C14.8333 15 13.3333 13.5 13.3333 11.6667C13.3333 9.83333 14.8333 8.33333 16.6667 8.33333Z'
        fill={color}
      />
      <path
        d='M6.66667 28.3333C7.03333 27.1333 12.1833 25 16.6667 25C16.6667 23.8333 16.8833 22.7167 17.25 21.6833C12.7 21.5167 3.33333 23.7833 3.33333 28.3333V31.6667H19.2333C18.3667 30.7 17.6833 29.5833 17.25 28.3333H6.66667Z'
        fill={color}
      />
      <path
        d='M32.3833 28.3667C32.9833 27.3833 33.3333 26.2333 33.3333 25C33.3333 21.3167 30.35 18.3333 26.6667 18.3333C22.9833 18.3333 20 21.3167 20 25C20 28.6833 22.9833 31.6667 26.6667 31.6667C27.9 31.6667 29.05 31.3 30.0333 30.7167C31.5833 32.2667 32.7333 33.4167 34.3167 35L36.6667 32.65C34.1667 30.15 35.35 31.3167 32.3833 28.3667ZM26.6667 28.3333C24.8333 28.3333 23.3333 26.8333 23.3333 25C23.3333 23.1667 24.8333 21.6667 26.6667 21.6667C28.5 21.6667 30 23.1667 30 25C30 26.8333 28.5 28.3333 26.6667 28.3333Z'
        fill={color}
      />
    </svg>
  )
}

export default PersonSearchIcon
